import React from "react";
import { ItemProps } from "./interfaces";

/**
 * This either returns the inline script tag to rehydrate the navigation data object from DOM elements,
 * or NULL, if executed in a browser.
 */
export function inlineScript() {
    if (typeof window !== "undefined") {
        return null;
    } else {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const fs = require("fs");
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const path = require("path");
        const scriptPath = path.resolve(process.cwd(), "./public/rehydrateNavigationFromDom.min.js");
        const code = fs.readFileSync(scriptPath, "utf8");
        return <script dangerouslySetInnerHTML={{ __html: code }} />;
    }
}

/**
 * This calculates the transform css property for the 2nd level navigation, since it should
 * be moved inverted to the main navigation, if the main nav is moved horizontally.
 */
export function calcTransform(isBrowser: boolean, movement: number | null, invert = false) {
    if (!isBrowser) {
        return undefined;
    }

    if (!movement) {
        return { transform: "translateX(0)" };
    }

    return { transform: `translateX(${invert ? "" : "-"}${movement}px)` };
}

export function getItems(): ItemProps[] {
    const itemCache: ItemProps[] | null = null;
    if (itemCache) {
        return itemCache;
    }

    if (typeof window !== "undefined") {
        return window.navItems;
    } else {
        const cwd = process.cwd();
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const path = require("path");
        return __non_webpack_require__(path.resolve(cwd, "./public/navigationItems.json"));
    }
}
